
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const navigate = useNavigate();

  const scrollToApplication = () => {
    const element = document.getElementById('application-form-title');
    if (element) {
      const headerHeight = 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleWhyFreeClick = () => {
    navigate('/why-free');
  };

  return (
    <>
      <section 
        id="hero-section" 
        className="relative bg-white pt-8 pb-12 lg:pt-12 lg:pb-16"
      >
        {/* Content */}
        <div className="relative z-10 w-full">
          <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
              {/* Mobile Image - Shows only on mobile */}
              <div className="lg:hidden w-full mb-6">
                {/* モバイル専用キャッチコピー */}
                <div className="bg-gradient-to-r from-rose-200 to-pink-200 text-gray-800 text-center py-8 px-6 rounded-2xl shadow-2xl mb-4 border border-rose-300 animate-pulse-slow">
                  <h2 className="text-3xl font-bold mb-3 bg-gradient-to-r from-rose-500 to-pink-600 bg-clip-text text-transparent" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    モニター会員募集！
                  </h2>
                  <p className="text-2xl font-bold mb-3 bg-gradient-to-r from-rose-500 to-pink-600 bg-clip-text text-transparent" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    会費無料・商品無料
                  </p>
                  <p className="text-xl font-bold bg-gradient-to-r from-rose-500 to-pink-600 bg-clip-text text-transparent" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    ※条件により謝礼もあり
                  </p>
                </div>

                <img 
                  src="https://static.readdy.ai/image/4b22fec895be8868ec3e756cd14dfaa5/cf85efc4655a842b9ce3384f1a85418d.png"
                  alt="モニター友の会"
                  className="w-full h-auto rounded-2xl shadow-2xl object-cover"
                  loading="eager"
                />
              </div>

              {/* Left side - Image (Desktop only) */}
              <div className="hidden lg:flex lg:flex-col lg:gap-6">
                <img 
                  src="https://static.readdy.ai/image/4b22fec895be8868ec3e756cd14dfaa5/cf85efc4655a842b9ce3384f1a85418d.png"
                  alt="モニター友の会"
                  className="w-full h-auto rounded-2xl shadow-2xl object-cover"
                  loading="eager"
                />
                
                {/* Desktop用 みんなの体験実績 - 画像の下 */}
                <div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-2xl p-6 border border-rose-100 shadow-lg">
                  <h3 className="text-lg font-bold text-gray-800 mb-4 text-center flex items-center justify-center">
                    <div className="w-8 h-8 bg-gradient-to-br from-rose-400 to-pink-500 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-group-line text-white text-base"></i>
                    </div>
                    みんなの体験実績
                  </h3>
                  <div className="grid grid-cols-2 gap-4">
                    <div className="bg-white rounded-2xl p-6 border border-rose-100 shadow-md">
                      <div className="flex items-center mb-3">
                        <div className="w-10 h-10 bg-gradient-to-br from-rose-400 to-pink-500 rounded-full flex items-center justify-center mr-3">
                          <i className="ri-calendar-check-line text-white text-lg"></i>
                        </div>
                        <h4 className="font-bold text-gray-800 text-sm">月平均</h4>
                      </div>
                      <p className="text-3xl font-bold bg-gradient-to-r from-rose-500 to-pink-600 bg-clip-text text-transparent mb-1">7点</p>
                      <p className="text-xs text-gray-600">体験商品数</p>
                    </div>
                    
                    <div className="bg-white rounded-2xl p-6 border border-amber-100 shadow-md">
                      <div className="flex items-center mb-3">
                        <div className="w-10 h-10 bg-gradient-to-br from-amber-400 to-yellow-5 0 rounded-full flex items-center justify-center mr-3">
                          <i className="ri-money-yen-circle-line text-white text-lg"></i>
                        </div>
                        <h4 className="font-bold text-gray-800 text-sm">月平均</h4>
                      </div>
                      <p className="text-3xl font-bold bg-gradient-to-r from-amber-500 to-yellow-600 bg-clip-text text-transparent mb-1">23,000円</p>
                      <p className="text-xs text-gray-600">体験価値相当</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right side - Text Content */}
              <div className="bg-white rounded-3xl p-6 lg:p-8 shadow-2xl border border-gray-100">
                <div className="text-left space-y-5">
                  {/* Desktop キャッチコピー - PC版のみ表示 */}
                  <div className="hidden lg:block bg-gradient-to-r from-rose-200 to-pink-200 text-gray-800 text-center py-5 px-5 rounded-2xl shadow-2xl mb-5 border border-rose-300 animate-pulse-slow">
                    <h2 className="text-2xl font-bold mb-2 bg-gradient-to-r from-rose-500 to-pink-600 bg-clip-text text-transparent" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                      モニター会員募集！
                    </h2>
                    <p className="text-xl font-bold mb-2 bg-gradient-to-r from-rose-500 to-pink-600 bg-clip-text text-transparent" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                      会費無料・商品無料
                    </p>
                    <p className="text-lg font-bold bg-gradient-to-r from-rose-500 to-pink-600 bg-clip-text text-transparent" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                      ※条件により謝礼もあり
                    </p>
                  </div>

                  {/* Trust Badge */}
                  <div className="inline-flex items-center bg-rose-50 border border-rose-200 text-rose-700 px-4 py-2 rounded-full font-medium text-sm shadow-lg">
                    <div className="w-2 h-2 bg-rose-400 rounded-full mr-3 animate-pulse"></div>
                    全国約2,200名が参加する安心コミュニティ
                  </div>

                  {/* Main Headline */}
                  <h1 className="text-3xl md:text-4xl lg:text-4xl font-bold leading-tight" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                    <span className="bg-gradient-to-r from-rose-400 to-pink-500 bg-clip-text text-transparent block">あなたの声が</span>
                    <span className="text-gray-800 block">みんなの<span className="bg-gradient-to-r from-rose-400 to-pink-500 bg-clip-text text-transparent">"欲しい"</span>を</span>
                    <span className="bg-gradient-to-r from-rose-400 to-pink-500 bg-clip-text text-transparent block">カタチにします。</span>
                  </h1>

                  {/* Subtitle */}
                  <div className="bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 rounded-3xl p-8 shadow-lg border border-blue-100 relative overflow-hidden">
                    {/* 装飾的な背景要素 */}
                    <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-200/30 to-purple-200/30 rounded-full -translate-y-16 translate-x-16"></div>
                    <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-indigo-200/30 to-blue-200/30 rounded-full translate-y-12 -translate-x-12"></div>
                    
                    <div className="relative z-10">
                      {/* アイコンヘッダー */}
                      <div className="flex items-center mb-6">
                        <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-full flex items-center justify-center mr-4 shadow-lg">
                          <i className="ri-information-line text-white text-xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-800" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                          モニター友の会とは
                        </h3>
                      </div>

                      {/* メインコンテンツ */}
                      <div className="space-y-5">
                        {/* 説明カード1 */}
                        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-5 border border-blue-100 shadow-md">
                          <div className="flex items-start">
                            <div className="w-8 h-8 bg-gradient-to-br from-rose-400 to-pink-500 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                              <i className="ri-flask-line text-white text-sm"></i>
                            </div>
                            <div>
                              <h4 className="font-bold text-gray-800 mb-2 text-base">新商品を試して<br className="sm:hidden" />感想を投稿する会です</h4>
                              <p className="text-gray-600 text-sm leading-relaxed">
                                最新の商品をいち早く体験し、あなたの率直な感想をお聞かせください
                              </p>
                            </div>
                          </div>
                        </div>

                        {/* 説明カード2 */}
                        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-5 border border-emerald-100 shadow-md">
                          <div className="flex items-start">
                            <div className="w-8 h-8 bg-gradient-to-br from-emerald-400 to-green-500 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                              <i className="ri-gift-line text-white text-sm"></i>
                            </div>
                            <div>
                              <h4 className="font-bold text-gray-800 mb-2 text-base">参加に必要な商品代は<br className="sm:hidden" />当センターが負担します</h4>
                              <p className="text-gray-600 text-sm leading-relaxed">
                                商品代金は一切かかりません。安心してご参加いただけます
                              </p>
                            </div>
                          </div>
                        </div>

                        {/* 説明カード3 */}
                        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-5 border border-purple-100 shadow-md">
                          <div className="flex items-start">
                            <div className="w-8 h-8 bg-gradient-to-br from-purple-400 to-violet-500 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                              <i className="ri-team-line text-white text-sm"></i>
                            </div>
                            <div>
                              <h4 className="font-bold text-gray-800 mb-2 text-base">メーカー様とモニター様を<br className="sm:hidden" />つなぐ架け橋です</h4>
                              <p className="text-gray-600 text-sm leading-relaxed">
                                メーカー様のご依頼で、モニター様の貴重なご感想を取りまとめています。商品代等の費用はメーカー様が負担するため、モニター様の費用負担は一切ありません
                              </p>
                            </div>
                          </div>
                        </div>

                        {/* 注意事項 */}
                        <div className="bg-gradient-to-r from-amber-50 to-yellow-50 rounded-2xl p-5 border border-amber-200 shadow-md">
                          <div className="flex items-start">
                            <div className="w-8 h-8 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                              <i className="ri-star-line text-white text-sm"></i>
                            </div>
                            <div>
                              <h4 className="font-bold text-gray-800 mb-2 text-base">体験に基づく正直な<br className="sm:hidden" />レビューをお願いしています</h4>
                              <p className="text-gray-600 text-sm leading-relaxed">
                                良い点も改善点も含めて、ありのままの感想をお聞かせください
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Stats Cards - モバイルのみ表示 */}
                  <div className="lg:hidden bg-gray-50 rounded-2xl p-4 shadow-lg border border-gray-100">
                    <h3 className="text-base font-bold text-gray-800 mb-4 text-center flex items-center justify-center">
                      <div className="w-7 h-7 bg-gradient-to-br from-rose-400 to-pink-500 rounded-full flex items-center justify-center mr-2">
                        <i className="ri-group-line text-white text-sm"></i>
                      </div>
                      みんなの体験実績
                    </h3>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                      <div className="bg-white rounded-xl p-3 text-center border border-rose-100 shadow-sm">
                        <div className="mb-2 w-full h-48 flex items-center justify-center">
                          <img 
                            src="https://public.readdy.ai/ai/img_res/30a44fe80043afdc0fe4e9c9716cea7d.jpg"
                            alt="体験商品数"
                            className="w-full h-full object-cover rounded-lg"
                          />
                        </div>
                        <div className="text-xl font-bold bg-gradient-to-r from-rose-500 to-pink-600 bg-clip-text text-transparent mb-1">月平均7点</div>
                        <div className="text-xs text-gray-600 font-medium">体験商品数</div>
                      </div>
                      <div className="bg-white rounded-xl p-3 text-center border border-amber-100 shadow-sm">
                        <div className="mb-2 w-full h-48 flex items-center justify-center">
                          <img 
                            src="https://readdy.ai/api/search-image?query=Digital%20payment%20and%20money%20concept%20illustration%20with%20smartphone%20showing%20money%20transfer%2C%20Japanese%20yen%20bills%20and%20coins%20floating%20around%2C%20modern%20financial%20technology%2C%20amber%20and%20yellow%20color%20scheme%2C%20clean%20white%20background%2C%20representing%20monetary%20value%20and%20rewards&width=400&height=400&seq=stats2&orientation=squarish"
                            alt="月平均体験価値"
                            className="w-full h-full object-cover rounded-lg"
                          />
                        </div>
                        <div className="text-xl font-bold bg-gradient-to-r from-amber-500 to-yellow-600 bg-clip-text text-transparent mb-1">23,000円相当</div>
                        <div className="text-xs text-gray-600 font-medium">月平均体験価値</div>
                      </div>
                      <div className="bg-white rounded-xl p-3 text-center border border-rose-100 shadow-sm">
                        <div className="mb-2 w-full h-48 flex items-center justify-center">
                          <img 
                            src="https://readdy.ai/api/search-image?query=Diverse%20group%20of%20Japanese%20women%20community%20members%20smiling%20and%20connecting%20together%2C%20warm%20and%20welcoming%20atmosphere%20with%20various%20ages%20and%20styles%2C%20modern%20flat%20illustration%20style%2C%20rose%20and%20pink%20color%20accents%2C%20clean%20white%20background%2C%20representing%20active%20community%20participation&width=400&height=400&seq=stats3&orientation=squarish"
                            alt="参加メンバー"
                            className="w-full h-full object-cover rounded-lg"
                          />
                        </div>
                        <div className="text-xl font-bold bg-gradient-to-r from-rose-500 to-pink-600 bg-clip-text text-transparent mb-1">約2,200名</div>
                        <div className="text-xs text-gray-600 font-medium">参加メンバー</div>
                      </div>
                    </div>
                  </div>

                  {/* Safety Points - モバイルのみ表示 */}
                  <div className="lg:hidden bg-gray-50 rounded-2xl p-4 shadow-lg border border-gray-100">
                    <h3 className="text-base font-bold text-gray-800 mb-4 text-center flex items-center justify-center">
                      <div className="w-7 h-7 bg-gradient-to-br from-emerald-400 to-green-500 rounded-full flex items-center justify-center mr-2">
                        <i className="ri-shield-check-line text-white text-sm"></i>
                      </div>
                      安心して参加できる理由
                    </h3>
                    <div className="grid grid-cols-3 gap-3">
                      <div className="text-center">
                        <div className="mb-2 w-full h-48 flex items-center justify-center">
                          <img 
                            src="https://readdy.ai/api/search-image?query=Friendly%20Japanese%20women%20community%20group%20illustration%20showing%20diverse%20Japanese%20women%20of%20various%20ages%20smiling%20and%20supporting%20each%20other%20in%20a%20warm%20welcoming%20atmosphere%2C%20soft%20pastel%20pink%20and%20coral%20colors%20with%20gentle%20lighting%2C%20modern%20flat%20illustration%20style%20with%20clean%20composition%2C%20simple%20white%20background%2C%20representing%20female-centered%20safe%20community%20space&width=400&height=400&seq=safety1sq&orientation=squarish"
                            alt="女性専用コミュニティ"
                            className="w-full h-full object-cover rounded-lg"
                          />
                        </div>
                        <div className="font-bold text-gray-800 mb-1 text-xs">女性専用</div>
                        <div className="text-gray-600 text-xs">コミュニティ</div>
                      </div>
                      <div className="text-center">
                        <div className="mb-2 w-full h-48 flex items-center justify-center">
                          <img 
                            src="https://readdy.ai/api/search-image?query=Professional%20customer%20support%20illustration%20showing%20friendly%20Japanese%20female%20support%20staff%20with%20headset%20providing%20caring%20assistance%2C%20warm%20and%20approachable%20service%20representative%20smiling%20while%20helping%20customers%2C%20soft%20yellow%20and%20amber%20colors%20with%20professional%20atmosphere%2C%20modern%20flat%20illustration%20style%2C%20clean%20white%20background%2C%20representing%20attentive%20dedicated%20support&width=400&height=400&seq=safety2sq&orientation=squarish"
                            alt="丁寧なサポート体制"
                            className="w-full h-full object-cover rounded-lg"
                          />
                        </div>
                        <div className="font-bold text-gray-800 mb-1 text-xs">丁寧な</div>
                        <div className="text-gray-600 text-xs">サポート体制</div>
                      </div>
                      <div className="text-center">
                        <div className="mb-2 w-full h-48 flex items-center justify-center">
                          <img 
                            src="https://readdy.ai/api/search-image?query=Personal%20data%20security%20and%20privacy%20protection%20illustration%20with%20shield%20and%20lock%20symbol%2C%20secure%20encrypted%20database%20and%20protected%20information%2C%20professional%20teal%20and%20green%20colors%20with%20trust%20elements%2C%20modern%20flat%20illustration%20style%20with%20security%20badges%2C%20clean%20white%20background%2C%20representing%20strict%20information%20management%20and%20privacy%20mark%20certification&width=400&height=400&seq=safety3sq&orientation=squarish"
                            alt="個人情報の厳重管理"
                            className="w-full h-full object-cover rounded-lg"
                          />
                        </div>
                        <div className="font-bold text-gray-800 mb-1 text-xs">個人情報の</div>
                        <div className="text-gray-600 text-xs">厳重管理</div>
                      </div>
                    </div>
                  </div>

                  {/* CTA Buttons */}
                  <div className="space-y-3">
                    <Button
                      onClick={scrollToApplication}
                      className="w-full bg-gradient-to-r from-teal-500 to-emerald-5 0 hover:from-teal-600 hover:to-emerald-600 text-white px-8 py-4 rounded-xl text-lg font-bold shadow-xl transition-all duration-300 whitespace-nowrap cursor-pointer transform hover:scale-105 hover:shadow-2xl"
                    >
                      <i className="ri-gift-line mr-3 text-lg"></i>
                      商品モニター会員応募
                    </Button>
                    
                    <div className="text-center">
                      <Button
                        onClick={handleWhyFreeClick}
                        className="bg-gray-100 hover:bg-gray-200 text-gray-700 hover:text-gray-800 px-6 py-3 rounded-full text-base font-medium shadow-lg transition-all duration-300 whitespace-nowrap cursor-pointer border border-gray-200"
                      >
                        <i className="ri-question-line mr-2"></i>
                        なぜ無料で体験できるの？
                      </Button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
